/* RESPONSIBLE TEAM: team-frontend-tech */
export default function (tmap) {
  tmap.transition(tmap.hasClass('animation__feed'), tmap.use('crossFade'));
}
